import React, {Component} from "react";
import { withRouter } from "react-router-dom";
import logo from "../../assets/images/cel-corner-logo.png";

class CELBranding extends Component {

  redirect = () => {
      console.log("Redirecting")
      this.props.history.push("/main");
  }

  render() {
    return (
        <div className="branding" onClick={this.redirect}>
            <img 
                className="logo"
                src={logo} 
                alt="logo"
            />
        </div>

    )
  }

}

export default withRouter(CELBranding);